/* eslint-disable react-hooks/exhaustive-deps */
import { Footer, Header, Layout } from '@davies-group/white-label-ui/ui';
import * as React from 'react';
import { Navigate, PathRouteProps, Route, Routes } from 'react-router-dom';

import { useDocumentUpload } from './context/DocumentUploadContext';
import ClientUpload from './pages/ClientUpload';
import completedPage from './pages/Completed';
import errorPage from './pages/Error';
import { Home } from './pages';
import { applicationSettings } from './utils';

const routes = [Home, ClientUpload, errorPage, completedPage];

const noMatchRoute: PathRouteProps = {
    path: '*',
    element: <Navigate to={`/${applicationSettings.invalidRequestId}/error`} />,
};

export default function AppContainer() {
    const { state } = useDocumentUpload();

    const getRoutes = (): JSX.Element[] => {
        const routeElements: JSX.Element[] = [];
        routes.map((r) => routeElements.push(<Route key={r.title} {...r.route} />));
        return routeElements;
    };

    return (
        <Layout header={<Header enableLogoHref={false} elevation={0} />} footer={<Footer appName={applicationSettings.applicationName} appVersion={applicationSettings.applicationVersion} appCopyright={applicationSettings.applicationCopyright} />} isLoading={state.isLoading} maxWidth="lg">
            <>
                <Routes>
                    {getRoutes()}
                    <Route key={'no-match'} {...noMatchRoute} />
                </Routes>
            </>
        </Layout>
    );
}
